<template>
  <div>
    <div class="container">
      <div class="row  container-fluid" v-if="CinemaList.length == 0">
        <div class="col-12 text-center">
          <img src="@/assets/img/loadMore.gif" class="load-more" />
        </div>
      </div>
    
      <div class="movie-information bg-light py-0">
       
      </div>
      
      <div class="col-12" v-if="CinemaList.length > 0">
        <div
          class="col-12 col-md-10 col-lg-8 col-xl-6 mb-md-4 mb-3 py-2 px-0 grp-drop mt-3"
        >
          <b-input-group>
            <b-button variant="default" class="pr-1">
              <img src="@/assets/img/icons/Shape.png" height="19" width="19" />
            </b-button>
            <b-form-input
              @keyup.native="searchData()"
              v-model="searchValue"
              placeholder="Search for cinema"
              class="pl-1"
            />
         
          </b-input-group>
        </div>
        <!-- ************************************************** -->
        
        <!-- ************************************************** -->
                 <ul
                      class="movie-listing-mobile mt-2"
                      v-if="loadingContent == false && CinemaList.length > 0"
                    >
                    <!-- {{CinemaList}} -->
                      <li
                        v-for="(listing, listingKey) in CinemaList"
                        :key="listingKey"
                        v-on:click="onSelectCinema(listing)"
                        :class="{ active: selectedCinemaObject === listing }"
                      >
                        <div class="row">
                          <!-- <div class="organisation-name"> -->
                          <div class="col-8 col-md-9 organisation-name">
                            <!-- {{ listing.OrganizationName }} -->
                            {{ listing.cinema_name }} 
                          </div>
                          <!-- <span class="text-danger" style="float:right">&nbsp; $1200</span> -->
                          <div
                            class="col-4 col-md-3 organisation-name align-self-end"
                          >
                            <span class="font-small d-block "
                              >Starting From</span
                            >
                          </div>
                          <!-- </div> -->
                          <div class="col-8 col-md-9">
                            <div class="organisation-address">
                              {{ listing.cinema_address }} {{ listing.cinema_location?`, ${listing.cinema_location}`:listing.cinema_location  }}
                            </div>
                             <ul
                              class="organisation-features"
                              v-if="listing.mf_name.length > 0"
                            >
                              <li v-for="(item, index) in listing.mf_name" :key="index">
                                {{ item }}
                              </li>
                            </ul>
                          
                            <!-- <div class="membership-promo">Membership promotion here</div> -->
                            <!-- <ul class="orginistion-recent-scheduling">
                                             <li class="pl-0">Recent Shows</li>
                                             <li>20:20</li>
                                             <li>21:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             <li>23:20</li>
                                             </ul>-->
                          </div>
                          <div class="col-4 col-md-3">
                            <div class="organisation-name">
                              <span class="price">
                               {{curr_code}}
                                {{String(listing.starting_price).split(".")[0]}}.<sup>{{String(listing.starting_price).split(".")[1].length==1?String(listing.starting_price).split(".")[1]+'0':String(listing.starting_price).split(".")[1]}}</sup>
                              </span>
                            </div>
                            <div class="organisation-distance text-left" v-if="false">
                              {{ listing.Distance }}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
        <div
          class="my-4"
          v-else-if="CinemaList.length == 0 && loadingContent == false"
        >
          <h5 class="text-center">No Cinema Found</h5>
        </div>
        <div
          class="row  container-fluid"
          v-else-if="loadingContent && filterListCinema.length > 0"
        >
          <div class="col-12 text-center">
            <img src="@/assets/img/loadMore.gif" class="load-more" />
          </div>
        </div>
      </div>
    </div>
    <b-modal
      hide-header-close
      hide-footer
      ref="filterModalRef"
      id="filterModal"
      title="Choose Any Filter"
      modal-class="welcome-b"
    >
      <button
        type="button"
        @click="hideFilter()"
        aria-label="Close"
        class="close"
      >
        ×
      </button>
    </b-modal>
  </div>
</template>
<script>
import { makeRequest } from "@/helper/internet.js";
import EventBus from "@/eventBus.js";
import loader from "@/components/partials/loader.vue";
import MainServices from "@/services/mainService.js";

export default {
  data() {
    return {
      searchValue: "",
      loadingContent: true,
      CinemaList: [],
      CinemaListCopy: [],
      filterListCinema: [],
      filterObj: {},
      checkSize: "",
      CityArray: [],
      selectedCinemaObject:{}
    };
  },
  components: {
    loader
  },
  computed:{
     curr_code() {
      return this.$store.getters.getCurrCode;
    },

  },
  beforeMount() {
    this.fetchCinemasList();
  },
  beforeDestroy() {
    EventBus.$emit("FOOTERSET", false);
    EventBus.$emit("CHECKROUTE", false);
  },
  mounted() {
    EventBus.$emit("CHECKROUTE", true);
    EventBus.$emit("BOTTOMTABCHANGE", "5");
  },
  methods: {
    searchData: function() {
      this.selectedCinemaObject = {};
      this.CinemaList = this.CinemaListCopy;
      if (this.searchValue.length > 0) {
        this.CinemaList = this.CinemaList.filter(cinema => {
          let str = this.searchValue.toLowerCase();
          let cinemaName = cinema.cinema_name.toLowerCase();
          if (cinemaName.includes(str)) {
            return cinema;
          }
        });
      } else {
        this.CinemaList = this.CinemaListCopy;
      }
    },
    filterListAll(org, index2, index1) {
      this.filterListCinema[index1]["list"].map(x => {
        x["Show"] = false;
      });
      this.filterListCinema[index1]["list"][index2]["Show"] = true;
      this.loadingContent = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    showFilter(index) {
      if (this.checkSize != "" && this.filterListCinema[index]["Show"]) {
        this.filterListCinema[index]["Show"] = false;

        this.closeFilter();
        return false;
      }

      this.filterListCinema.map(x => {
        x["Show"] = false;
      });
      this.filterListCinema[index]["Show"] = true;
      if (screen.width > 992) {
        this.checkSize = "2";
      } else {
        this.checkSize = "1";
      }
      var element = document.getElementsByTagName("body")[0];

      element.classList.add("overflow-hidden");
    },
    closeFilter() {
      this.checkSize = "";
      var element = document.getElementsByTagName("body")[0];
      element.classList.remove("overflow-hidden");
      this.filterListCinema.map(x => {
        x["Show"] = false;
      });
    },
    clearAllState(index1) {
      this.filterListCinema[index1]["list"].map(x => {
        x["Show"] = false;
      });
      this.loadingContent = true;
      this.CityArray = [];
      this.closeFilter();
      this.fetchCinemasList();
    },
    FilterAllState(index1) {
      this.filterListCinema[index1]["list"].map(x => {
        x["Show"] = false;
      });
      this.loadingContent = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    CityList(state, index2, index1) {
      this.filterListCinema[index1]["list"].map(x => {
        x["Show"] = false;
      });
      //  console.log( this.filterListCinema[index1]["list"][index2]["Show"],"sfdfsdfdsfdsf");
      this.filterListCinema[index1]["list"][index2]["Show"] = true;
      this.CityArray = state.CityList;
    },
    DistrictList(city, index3, index1) {
      this.CityArray.map(x => {
        x["Show"] = false;
      });
      //  console.log( this.CityArray[index3]["Show"],"sfdfsdfdsfdsf");
      this.CityArray[index3]["Show"] = true;
      this.closeFilter();
      this.fetchCinemasList();
    },
    onSelectCinema(listing) {
      this.$router.push({
        path: "/cinemaScreen/" + listing.cinema_id
      });
    },
    fetchCinemasList: function() {
         this.loadingContent = true;
    
        MainServices.GetCinemaList({}).then(response => {
          const { error, data } = response;
          console.log(data.Records)
          this.CinemaList = data.Records;
          this.CinemaListCopy = data.Records;
          // if (count == 0) {
          //   this.filterListCinema = res.data.FilterList.FilterList;
          // }
          this.loadingContent = false;
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/cinemapage.vue